import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import {RouterModule} from '@angular/router';
import { ScrollDirective } from './directives/scroll.directive';
import {MatButtonModule, MatFormFieldModule, MatSelectModule, MatSidenavModule} from '@angular/material';



@NgModule({
  declarations: [HeaderComponent, ScrollDirective],
  exports: [
    HeaderComponent,
    ScrollDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule
  ]
})
export class HeaderModule { }
